import React from 'react';
import { IonCol, IonImg } from '@ionic/react';
import './MenuItemRow.scss';
import { baseUrl, cacheBust } from '../helpers/configHelper';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../store';

interface MenuItemTileProps {
    menuItemId: number;
    sku: string;
    price?: string;
    fromPrice?: boolean;
    productFlags: string[];
    inStock: boolean;
    name: string;
    onClick?: (menuItemId: number) => void;
    kcal?: number
    onAddClick?: (menuItemId: number) => void;
    plpRoundels?: string[]
}

const MenuItemTile: React.FC<MenuItemTileProps> = ({
    name,
    menuItemId,
    fromPrice,
    price,
    onClick,
    onAddClick,
    sku,
    productFlags,
    inStock,
    kcal,
}) => {
    const headerState = useSelector((state: ApplicationState) => state.headerFooter);

    return (
        <>
            <IonCol className={(!inStock ? "OutOfStock" : "")} size="6" onClick={() => inStock  && onClick && onClick(menuItemId)}>
                <div className={"MenuItem-Tile__container " + (onAddClick ? "withAddButton" : "")} >
                    <div className="MenuItem-Tile__image_container">
                        {productFlags &&
                            <div className="MenuItemTile-icon__container">
                                {productFlags.map((v) => {
                                    return <IonImg key={v} className="MenuItemIcon" src={`${baseUrl()}/images/assets/${v}.png`} />
                                })}
                            </div>
                        }
                        <IonCol>
                            <IonImg alt={name} className="MenuItemImage" src={`${baseUrl()}/images/ProductShots/${sku}_PLP.png?v=${cacheBust()}`} />
                        </IonCol>
                    </div>
                    <div className="detail-container">
                        <div className="item-name">{name}</div>

                        <div className="detail-inner-container">
                            {kcal!=null && <div className="item-kcal">{kcal}kcal</div>}
                            <div className="item-price">{fromPrice && price && <div className="item-from">from</div>}<div>{price}</div></div>
                        </div>
                    </div>

                    <div className="addButton" onClick={() => { inStock && onAddClick && inStock && onAddClick(menuItemId) }}>Add</div>

                </div>
                {
                    headerState?.showDebugLabel &&
                    <div className="miDebugLabel">
                        {sku} {name}
                    </div>
                }
            </IonCol>
        </>
    );
};

export default MenuItemTile;
